import presetChartTypeDescriptor from "./presets/PresetChartTypeDescriptors";

export {
  presetChartTypeDescriptor,
};